export default __webpack_public_path__ + "static/N0254-15d26f99f7094d21ae1700d11b4ea3b3.png";